import React from "react";

import styles from "./BonusSpendSelector.module.scss";

interface Props {
  balance: number;
  maxWriteOff: number;
  value: number;
  onChange: (value: number) => void;
}

export const BonusSpendSelector: React.FC<Props> = ({
  balance,
  maxWriteOff,
  value,
  onChange,
}) => {
  const maxAllowed = Math.floor(Math.min(maxWriteOff, balance));

  const setMax = () => onChange(maxAllowed);

  const handleSliderChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(Math.floor(Number(e.target.value)));
  };

  const percent = maxAllowed > 0 ? (value / maxAllowed) * 100 : 0;

  return (
    <div className={styles.Container}>
      <div className={styles.Header}>
        <span className={styles.Title}>Списать бонусы</span>
        <button type="button" className={styles.MaxButton} onClick={setMax}>
          Списать максимум
        </button>
      </div>

      <input
        type="range"
        min="0"
        max={maxAllowed}
        value={value}
        onChange={handleSliderChange}
        step="1"
        className={styles.Slider}
        style={{
          background: `linear-gradient(to right, var(--primary) 0%, var(--primary) ${percent}%, var(--border) ${percent}%, var(--border) 100%)`,
        }}
      />

      <div className={styles.ValueRow}>
        <span className={styles.Value}>Списать: {value} ₽</span>
        <span className={styles.MaxValue}>Макс: {maxAllowed} ₽</span>
      </div>
    </div>
  );
};
